import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import Banner from 'components/molecules/Banner/Banner';

const BanerWrapper = styled.div`
	margin-bottom: 0.75rem;
	display: flex;
	justify-content: center;
	align-items: center;
`;

const Baners = ({ banners }) => (
	<div className="row">
		{banners &&
			banners.map((banner, index) => (
				<BanerWrapper
					className={`
						col-12 
						${banners.length > 1 ? 'col-sm-6 col-lg-12' : ''}
						${banners.length > 2 ? 'col-md-4' : ''}
					`}
					key={index}
				>
					<Banner {...banner} />
				</BanerWrapper>
			))}
	</div>
);

Baners.propTypes = {
	banners: PropTypes.array.isRequired,
};

// Baners.defaultProps = {};

export default Baners;
